import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-carbon px-3 py-4 sm:px-6" data-id="element-41" data-mp="1hd1nvzbcra01">
      <div className="mx-auto max-w-2xl" data-id="element-42" data-mp="1hdula9of8n5i">
        <h2 className="text-center font-display text-[1.6rem] font-bold uppercase leading-none text-white sm:text-[2.2rem]" data-id="element-43" data-mp="1cf05lglr3epm">
          FREQUENTLY ASKED <span className="text-safety" data-id="element-44" data-mp="2a1qhlda2wd1r">QUESTIONS</span>
        </h2>
        <ul className="mt-2 space-y-1.5" data-id="element-45" data-mp="252vyea878mh4">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className={`overflow-hidden rounded-md border bg-graphite transition-colors duration-150 ease-out ${isOpen ? 'border-safety' : 'border-steel/60'}`} data-id="element-46" data-mp="2027yt05wmxba" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-2 px-2.5 py-2 text-left text-[0.8rem] font-bold text-white transition-colors duration-150 ease-out hover:text-safety focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-safety sm:text-[0.92rem]" data-id="element-47" data-mp="jpjf4ohoy7w1">
                  {f.q}
                  <ChevronDownIcon className={`h-4 w-4 shrink-0 text-safety transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-48" data-mp="11v5s678qrp1s" />
                </button>
                {isOpen ? <p id={`faq-${i}`} className="px-2.5 pb-2 text-[0.78rem] leading-[1.35] text-mist sm:text-[0.88rem]" data-id="element-49" data-mp="wynozbt27yrk">
                    {f.a}
                  </p> : null}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}